import { openModal } from '../../../../actions/modal.action';

const Question404Dialog = (dispatch) => {
  openModal({
    className: 'modal-alert-width',
    button1Text: 'Close',
    button1Action: 'closeModal',
    imageSrc: '/art-error-message.svg',
    body: `ERROR: can't show the question chart, question was not found in the database.`,
  })(dispatch);
};

export default Question404Dialog;
